<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import VipBenefitSection from "./vip-benefit-section.svelte";
const rewardKeys = [
	{
		titleKey: "daily_bonus",
		image: cfgToThemeCdnPath("/about-vip/daily.png")
	},
	{
		titleKey: "weekly_bonus",
		image: cfgToThemeCdnPath("/about-vip/weekly.png")
	},
	{
		titleKey: "monthly_bonus",
		image: cfgToThemeCdnPath("/about-vip/monthly.png")
	},
	{
		titleKey: "calendar_bonus",
		image: cfgToThemeCdnPath("/about-vip/calendar.png")
	}
];
</script>

<VipBenefitSection
	title={$t(Verbiage.cashback)}
	description={$t(Verbiage.vip_alt2_cashback_description)}
	rewards={rewardKeys.map((r) => ({ title: $t(Verbiage[r.titleKey]), image: r.image }))}
/>
